@use "@fukuri-admins/ui/layout" as *;

.title {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 16px;
  color: #676370;
}

.tableContainer {
  height: 720px;
  max-height: 90vh;
  border-bottom: 1px solid $Border;
  &.MuiTableContainer-root {
    border: none;
    padding: 0px;
    margin-bottom: 20px;
    .MuiTableRow-root {
      border-bottom: 1px solid #eee;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
    .MuiTableBody-root .MuiTableRow-root:last-child {
      border-bottom: solid 1px transparent;
    }
  }
  .MuiTableCell-root {
    white-space: nowrap;
    border-bottom: none;
  }
}

.tableContent {
  &.MuiTableHead-root {
    width: 900px;
    min-width: 100%;
    table-layout: auto;
  }
}
